<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "GrupaStatusaBase"
};
</script>

<style scoped>

</style>
